import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@nook/ui";
/** A source's favicon, or the Nook mark for a nook with no source or a site with no icon. */
export function SourceIcon({ icon, className }) {
    return icon ? _jsx("img", { src: icon, alt: "", "aria-hidden": true, className: cn("size-4 shrink-0 rounded-sm", className) }) : null;
}
//# sourceMappingURL=source-icon.js.map